// extracted by mini-css-extract-plugin
export default {"button":"mimic___style_button__qHdtG"};